<template>
  <section class="max-w-lg py-8 mx-auto">
    <ContentSectionLoader v-if="isLoading" />
    <Transition name="fade">
      <div v-if="!isLoading">
        <div class="mb-8 flex justify-between">
          <h3
            class="mt-0"
            v-text="'What information would you like included in this report?'"
          />
          <div>
            <button
              type="button"
              class="mr-2 btn btn--link"
              @click="selectAll"
              v-text="'Select All'"
            />
            |
            <button
              type="button"
              class="ml-2 btn btn--link"
              @click="selectNone"
              v-text="'Select None'"
            />
          </div>
        </div>
        <div class="flex mb-12 flex-wrap justify-start">
          <div
            v-for="(column, key) in columns"
            :key="column"
            class="flex text-left items-center w-1/5"
          >
            <div class="w-full mr-2 p-3 my-2 flex items-center">
              <input
                :id="column"
                v-model="selectedColumns"
                :name="column"
                :value="column"
                type="checkbox"
                @change="updateSelectedColumns"
              >
              <label
                :for="column"
                class="mb-0 block"
                v-text="key"
              />
            </div>
          </div>
        </div>
        <div class="flex justify-center m-6">
          <button
            type="button"
            class="btn"
            :disabled="selectedColumns.length === 0"
            :aria-disabled="selectedColumns.length === 0"
            @click="handleTabNavigation"
            v-text="'Next'"
          />
        </div>
      </div>
    </Transition>
  </section>
</template>

<script type="text/babel">
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SelectColumns',
  props: {
    preSelected: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedColumns: this.preSelected,
      isLoading: true,
    }
  },
  computed: {
    ...mapGetters({
      columns: 'membershipGetAvailableReportColumns',
    }),
  },
  watch: {
    preSelected(element) {
      if (element) {
        this.selectedColumns = element
      }
    },
  },
  mounted() {
    this.getAvailableColumns()
      .then(() => {
        if (this.preSelected.length === 0) {
          this.$emit('columnsSelected', Object.values(this.columns))
        }

        this.isLoading = false
      })
  },
  methods: {
    ...mapActions({
      getAvailableColumns: 'membershipGetAvailableReportColumns',
    }),
    updateSelectedColumns() {
      this.$emit('columnsSelected', this.selectedColumns)
    },
    selectAll() {
      this.$emit('columnsSelected', Object.values(this.columns))
    },
    selectNone() {
      this.$emit('columnsSelected', [])
    },
    handleTabNavigation() {
      this.$emit('tabNavigation', {
        current: 'selectColumns',
        direction: 'next',
      })
    },
  },
}
</script>
